import { ComputerOutlined, LocationOnOutlined } from '@mui/icons-material';
import { Box, Divider, Stack, Typography } from '@mui/material';

import { LabelValue } from '../../components/general/LabelValue';
import { Tag } from '../../components/general/Tag';
import { LeistungIndexTags } from '../../components/general/ThemaHeader/LeistungIndexTags.tsx';
import { type ModulFromThemaRouter } from '../../dtos';
import { formatDuration } from '../../utils/dateFormat/durationFormat';
import { getLeistungstemplatesFromModul } from '../../utils/getLeistungstemplatesFromModul.ts';
import { printModulFormat } from '../../utils/printModulFormat.ts';

type ModulCardProps = {
  readonly modul: ModulFromThemaRouter;
};

export const SidebarModulCard = ({ modul }: ModulCardProps) => (
  <Box
    sx={{
      p: 2,
      backgroundColor: (theme) => theme.palette.surface.elevated,
      borderRadius: '4px',
      border: (theme) => `1px solid ${theme.palette.border.subtle}`,
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
      <Typography variant="label">Modul {modul.modulnummer}</Typography>

      {modul.beginn && (
        <Tag style="outline" size="small">{`${modul.beginn.text} ${modul.beginn.value} ${modul.beginn.unit}`}</Tag>
      )}
    </Stack>

    <Stack direction="column" alignItems="flex-start" spacing={1.5} alignSelf="stretch">
      <div className="flex gap-8">
        <Tag style="brand" size="small">
          {modul.isOnline ? (
            <ComputerOutlined sx={{ fontSize: '16px' }} />
          ) : (
            <LocationOnOutlined sx={{ fontSize: '16px' }} />
          )}
          {printModulFormat(modul.modulFormat)}
        </Tag>
        <LeistungIndexTags leistungstemplates={getLeistungstemplatesFromModul(modul)} />
      </div>

      {modul.titel && <LabelValue label="Titel" value={modul.titel} />}
      {modul.dauer && <LabelValue label="Dauer" value={formatDuration(modul.dauer)} />}
      {modul.ablaufUhrzeitenText && <LabelValue label="Uhrzeiten" value={modul.ablaufUhrzeitenText} />}
      {modul.trainer && <LabelValue label="Trainer:in" value={modul.trainer} />}
      {modul.gruppenraumInfo && <LabelValue label="Gruppenraum" value={modul.gruppenraumInfo} />}

      {modul.kommentar && (
        <>
          <Divider sx={{ width: '100%', height: '1px' }} />
          <Typography variant="labelLight">{modul.kommentar}</Typography>
        </>
      )}
    </Stack>
  </Box>
);
